import { Component, Input, inject } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { IOption } from '@models';
import { PathsEnum } from '@shared/enums/paths.enum';
import { DeviceDetectionService } from '@shared/providers/device-detection.service';
import { AlertService } from '@shared/providers/utilities/alert.service';

@Component({
    selector: 'anp-option-item',
    templateUrl: './option-item.component.html',
    styleUrls: ['./option-item.component.scss'],
    standalone: false
})
export class OptionItemComponent {
  @Input() public option: IOption;
  public readonly iconPath = PathsEnum.ICONS + 'options/';
  private readonly _deviceService = inject(DeviceDetectionService);

  public get isDesktop(): boolean {
    return this._deviceService.isDesktop;
  }

  constructor(private alertService: AlertService) {}

  async comingSoon(): Promise<void> {
    this.alertService.simpleAlert('Próximamente', 'Este funcionalidad estará disponible pronto!');
  }
}
